import { all, call, fork, put, take} from "redux-saga/effects";

import {IClientBookmarkRepository} from "../../domain/repository/client_bookmark_repository";

import {createClientBookmarkAPI} from "../../infra/api/service/client_bookmark_api";
import {createApiClient, IApiClient} from "../../infra/api/client";

import {handleErrorForHandler} from "./handleErrorForHandler";
import {
    ClientClientBookmarksActionType,
    createClientClientBookmarksActionCreator,
    IClientClientBookmarksActionCreator,
} from "../action/client_client_bookmarks_action";
import {ClientBookmark} from "../../domain/model/client_bookmark";
import {GetAllClientBookMarkByClientResponse} from "../response/client_bookmark_response";
import {Customer} from "../../domain/model/customer";
import {ICustomerRepository} from "../../domain/repository/customer_repository";
import {createCustomerAPI} from "../../infra/api/service/customer_api";
import {IJobCareerRepository, TJobCareerWithCustomerID} from "../../domain/repository/job_career_repository";
import {createJobCareerAPI} from "../../infra/api/service/job_career_api";

const apiClient: IApiClient = createApiClient();
const clientBookmarkRepository: IClientBookmarkRepository = createClientBookmarkAPI(apiClient);
const customerRepository: ICustomerRepository = createCustomerAPI(apiClient);
const jobcareerRepository: IJobCareerRepository = createJobCareerAPI(apiClient);
const actionCreator: IClientClientBookmarksActionCreator = createClientClientBookmarksActionCreator();

function* handleGetAllClientBookmarksInClientClientBookmarks() {
    while (true) {
        try {
            yield take(ClientClientBookmarksActionType.REQUEST_GET_ALL_CLIENT_BOOKMARKS);
            const clientBookmarks: ClientBookmark[] = yield call(getAllClientBookmark);
            const customerIds: string[] = yield call(createCustomerIds, clientBookmarks);
            let customers: Customer[];
            let jobCareersWithCustomerId: TJobCareerWithCustomerID[];
            [customers, jobCareersWithCustomerId] = yield all([
                call(getCustomerAllByIDs, customerIds),
                call(getJobcareerAllByCustomerIDs, customerIds)
            ]);

            const res: GetAllClientBookMarkByClientResponse = new GetAllClientBookMarkByClientResponse();
            res.clientBookmarks = clientBookmarks;
            res.customers = customers;
            res.jobCareersWithCustomerID = jobCareersWithCustomerId;
            yield put(actionCreator.callbackGetAllClientBookmarksAction(true,res));

        } catch (error) {
            yield fork(handleErrorForHandler, error);
            yield put(actionCreator.callbackGetAllClientBookmarksAction(false));
        }
    }
}

const getAllClientBookmark = (): Promise<ClientBookmark[]> => {
    return clientBookmarkRepository.getAllByClient();
};

const createCustomerIds = (clientBookmarks: ClientBookmark[]): string[] => {
    return clientBookmarks.map((clientBookmark: ClientBookmark) => {
        return clientBookmark.customerID
    })
};

const getCustomerAllByIDs = (customerIds: string[]): Promise<Customer[]> => {
    return customerRepository.getAllByIDs(customerIds);
};

const getJobcareerAllByCustomerIDs = (
    customerIds: string[],
): Promise<TJobCareerWithCustomerID[]> => {
    return jobcareerRepository.getAllByCustomerIDsForScout(
        customerIds,
    );
};

export {handleGetAllClientBookmarksInClientClientBookmarks}



// WEBPACK FOOTER //
// ./src/presentation/handler/client_client_bookmarks_handler.ts